import SectionIntro from "./SectionIntro";
import { guideItems } from "@/mocks/softwareData";

export default function DownloadGuide() {
  return (
    <section id="guide" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionIntro
          eyebrow="DOWNLOAD 101"
          title="下载百科 · 一看就会"
          desc="常见下载与安装问题集中讲解，四篇短文覆盖八成用户遇到的情况。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {guideItems.map((g) => (
            <article
              key={g.no}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-accent-200 hover:bg-accent-50/40"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${g.icon} text-xl`}></i>
                </span>
                <span className="font-display text-2xl font-black text-background-300">{g.no}</span>
              </div>
              <h3 className="mt-4 font-display text-base font-bold text-foreground-950">{g.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{g.summary}</p>
              <ol className="mt-4 space-y-2 border-t border-background-200 pt-3">
                {g.steps.map((s, i) => (
                  <li key={s} className="flex items-start gap-2 text-xs text-foreground-500">
                    <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-600">
                      {i + 1}
                    </span>
                    <span>{s}</span>
                  </li>
                ))}
              </ol>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}